<template>
  <div id="desk-header" class="desk-drap" :class='{"login-status":loginStatus}'>
  	  <div class="close-btn desk-no-drap" @click="closeAction"></div>
      <div class="minimize-btn desk-no-drap" @click="minimizeAction"></div>
  </div>
</template>

<script>
export default {
  name: "desk-header",
  data() {
    return {
      msg: "desk-header",
      loginStatus:false
    };
  },
  computed: {},
  methods: {
  	 minimizeAction() {
      console.log("minimize");
      this.electronWindowType("minimize");
    },
    closeAction() {
      console.log("close");
      this.electronWindowType("close");
    },
  },
  watch:{
    $route(to,from){
      console.log(from.path);//从哪来
      console.log(to);//到哪去
      if(to.name == "electronLogin" ){
      	this.loginStatus = true
      }else{
      	this.loginStatus = false
      }
    }
  },
  created() {},
  components: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
#desk-header {
    height:0.32rem;
    width: 100%;
    background: #D1D7E4;
    .minimize-btn,
    .close-btn {
    	float: right;
        // position: absolute;
        // margin-right: 22px;
        top: 0;
        width: 0.64rem;
        height: 0.32rem;
        background:#C5CBD7 url("~@/assets/images/electron/mini_ico_1.svg") no-repeat center center;
        background-size: 0.24rem auto;
        z-index: 100000000;
    }

    .close-btn {
        background:#FF542C url("~@/assets/images/electron/close.png") no-repeat center center;
    }
 }
 .login-status {
 	position: absolute;
 	top:4px;
 	right:0;
 	z-index: 1;
 	padding-top: 12px;
 	height: 36px;
 	background:rgba(255,255,255,0) !important;
 	.minimize-btn,.close-btn {
    background: #fff !important;
 		margin-right: 34px !important;
    top: 6px !important;
    width: 0.24rem !important;
    height: 0.24rem !important;
    background:url("~@/assets/images/electron/mini_ico_1.svg") no-repeat center center !important;
 	}
 .close-btn {
      background: url("~@/assets/images/electron/close-electron-login-btn.svg") no-repeat center center !important;
  }
 }
</style>